import { Flex } from "~/components/Flex";
import { ButtonProps, Paper, Typography } from "@mui/material";
import { AddConditionBuilderRow } from "~/components/ConditionBuilder/ConditionBuilderAddConditionRow/AddConditionBuilderRow";
import { ConditionBuilderSelectionRowHeader } from "~/components/ConditionBuilder/ConditionBuilderSelectionRow/ConditionBuilderSelectionRowHeader";
import { useSelectionRow } from "./hooks/useSelectionRow";
import { WorkspaceConditionRow } from "../ConditionRow/WorkspaceConditionRow";

interface WorkspaceConditionSelectionRowProps {
  selectionIndex: number;
  onRemove: ButtonProps["onClick"];
  showRemoveSelectionButton: boolean;
  isReadonly: boolean;
}

export const WorkspaceConditionSelectionRow = ({
  selectionIndex,
  onRemove,
  showRemoveSelectionButton,
  isReadonly,
}: WorkspaceConditionSelectionRowProps) => {
  const {
    canAddCondition,
    handleAddCondition,
    handleRemoveCondition,
    fields,
    getConditionError,
    getIsConditionTouched,
  } = useSelectionRow({
    selectionIndex,
  });

  return (
    <Paper
      component={Flex}
      flexDirection="column"
      gap={2}
      sx={{
        p: 3,
        bgcolor: "background.paper",
        pt: isReadonly ? 2 : 3,
      }}
    >
      <ConditionBuilderSelectionRowHeader
        showRemoveSelectionButton={showRemoveSelectionButton}
        selectionIndex={selectionIndex}
        onRemove={onRemove}
        title="ASSET"
      />
      <Flex gap={4} flexWrap="wrap" flexDirection="column">
        {fields.map((field, conditionIndex) => {
          return (
            <Flex flexDirection="column" key={field.id}>
              <WorkspaceConditionRow
                conditionIndex={conditionIndex}
                selectionIndex={selectionIndex}
                onRemove={() => handleRemoveCondition(conditionIndex)}
                isReadonly={isReadonly}
                key={field.id}
              />
              {getIsConditionTouched(conditionIndex) &&
                getConditionError(conditionIndex) && (
                  <Typography
                    variant="body2"
                    component="span"
                    color="error"
                    ml={12}
                    p={0.5}
                  >
                    {getConditionError(conditionIndex)}
                  </Typography>
                )}
            </Flex>
          );
        })}
      </Flex>
      {!isReadonly && (
        <AddConditionBuilderRow
          disabled={!canAddCondition}
          onClick={handleAddCondition}
        />
      )}
    </Paper>
  );
};
